import Sdk from "api.digitalpages.module.sdk.api";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  loadPlayerObserver,
  reloadUserData,
} from "../../store/reducers/userDataSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { commonSlice } from "../../store/reducers";
import { LastInteraction } from "./types";

var GO_INTERACTION = 0;
var LAST_REFERENCE = "";

export const usePlayer = (uidReference?: string, uidContext?: string) => {
  const utilizationRef = useRef(false);

  const [userData, setUserData] = useState<any[]>([]);
  const [lastInteraction, setLastInteraction] =
    useState<LastInteraction | null>(null);
  const [lastReference, setLastReference] = useState("");
  const dispatch = useDispatch();
  const player = useSelector<RootState>(
    (state) => state.userDataState.playerObserver
  );
  const referrer = useSelector<RootState>(
    (state) => state.commonState.referrer
  );

  const getAnnotations = async (targetUid: string) => {
    if (userData.length) return;
    const url = `cms/v1.1/user/data?target_uid=${targetUid}`;

    return await Sdk.Api.dynamic.bridge(url, null, "GET").then((response) => {
      if (response.result) {
        setUserData(response.result);
        return response.result;
      }
    });
  };

  const createInteraction = async () => {
    const url = `cms/v1.1/managed/content/reference/uid/${uidReference}/content`;

    await Sdk.Api.dynamic.bridge(url, null, "GET")
  };

  const getLastInteraction = async () => {
    if (!utilizationRef.current) {
      utilizationRef.current = true;
      await createInteraction();
      
      const url = `cms/v1.1/managed/content/reference/uid/${uidReference}/interaction`;

      await Sdk.Api.dynamic
        .bridge(url, null, "GET")
        .then(setLastInteraction)
        .catch(async (err) => {
          console.log(err)
        });
    }
  };

  const data: any = player;
  const history: any = referrer;

  const handleHighlight = async (params: any) => {
    const connectors = Sdk.Api.authorization.activeProject.connectors;
    if (connectors) {
      const connectorUser = connectors.find(
        (connector: any) => connector.type === "UserData_1"
      );
      if (!connectorUser) return;

      const userDataParams = {
        ...params,
        external_type: "mark-epub",
        target_type: "ManagedContentReference",
        context_type: "ManagedContent",
        context_uid: uidContext,
        target_uid: uidReference,
        name: null,
      };

      const url = `cms/v1.1/user/connector/uid/${connectorUser.uid}/data`;
      await Sdk.Api.dynamic
        .bridge(url, userDataParams, "POST")
        .then((response) => {
          LAST_REFERENCE = response.uid;
          getAnnotations(uidReference as string);
          dispatch(reloadUserData());
        });
    }
  };

  const handleAnnotation = async (userDataUid: string, params: any) => {
    const url = `cms/v1.1/user/data/uid/${userDataUid}`;
    await Sdk.Api.dynamic.bridge(url, params, "PUT").then(() => {
      dispatch(reloadUserData());
    });
  };

  const handleDeleteAnnotation = async (userDataUid: string) => {
    const url = `cms/v1.1/user/data/uid/${userDataUid}`;
    await Sdk.Api.dynamic.bridge(url, null, "DELETE").then(() => {
      setUserData(userData.filter((item) => item.uid != userDataUid));
      dispatch(reloadUserData());
    });
  };

  const getNoteWithoutUID = (annotation: any) => {
    const keys = ["start_position", "end_position", "chapter_index"];
    const { external_data } = annotation;
    const data = JSON.parse(external_data);
    const userDataFound = userData.find((user) => {
      const { external_data: user_external } = user;
      const dataExternal = JSON.parse(user_external);
      const deParam = keys.every((item) => data[item] === dataExternal[item]);
      if (deParam) return user;
    });
    if (userDataFound) return userDataFound.uid;
    return LAST_REFERENCE;
  };

  const trackProgress = async (userProgress: any) => {
    if (!lastInteraction) return;
    const params: LastInteraction = {
      ...lastInteraction,
      ...userProgress,
      activity_data: JSON.stringify(userProgress.activity_data),
    };


    setLastInteraction(params);

    if(lastInteraction.activity_data === params.activity_data) return
    
    console.log(params);

    const url = `cms/v1.1/managed/content/interaction/uid/${lastInteraction.uid}`;
    await Sdk.Api.dynamic.bridge(url, params, "PUT").catch((err) => {
      console.log("Ocorreu um erro ao registrar o progresso");
    });
  };

  useEffect(() => {
    if (data) {
      if (data.onBack) {
        history.map((item: string, id: number) => {
          if (item.includes("player")) {
            let hash = history[id - 1];
            if (hash === undefined || (hash ?? '').includes('player')) {
              hash = '#/inicio'
            }
            window.location.hash = hash;
          }
        });
        dispatch(commonSlice.actions.setRefferer("reset"));
        dispatch(loadPlayerObserver());
        return;
      }
      if (data.userInteraction) {
        const { type, userData: content } = data.userInteraction;
        var uid = "";
        if (type === "note" || type === "delete") {
          uid = content.uid ? content.uid : getNoteWithoutUID(content);
          if (type === "delete") {
            handleDeleteAnnotation(uid);
            return;
          } else {
            handleAnnotation(uid, {
              description: content.description,
              external_data: content.external_data,
            });
          }
        }
        if (type === "highligth") {
          handleHighlight(content);
          return;
        }

        if (type === "trackProgress") {
          trackProgress(content);
        }
      }
    }
  }, [data]);

  return {
    getAnnotations,
    getLastInteraction,
    handleAnnotation,
    handleHighlight,
    userData,
    lastReference,
    lastInteraction,
  };
};
